<div class="ng-bento">
	<wj-flex-grid #flexGrid
		class="bento-flex-grid has-row-hover"
		[itemsSource]="data"
		[showSort]="true">
	<ng-template wjFlexGridCellTemplate
		[cellType]="'RowHeader'"
		let-col="col"
		let-row="row"
		let-item="item">
		<div *ngIf="col.index === 0">{{ row.index+1 }}</div>
	</ng-template>
	<div *ngFor="let key of columnBindings">
		<wj-flex-grid-column
		*ngIf="key!=='selected'&&key!=='id'"
		min-width="120"
		width="*"
		header="{{key}}"
		binding="{{key}}"></wj-flex-grid-column>
	</div>
	</wj-flex-grid>
</div>
